export enum Color {
  white = '#FFFFFF',
  black = '#000000',
  blue = '#E7F5FF',
  blue100 = '#E6E9FA',
  orange = '#EE8030',
  green = '#00CCB1',
  greenDark = '#00B89F',
  teal = '#1D2932',
  red = '#FF6262',
  redDark = '#DE5B5B',
  yellow = '#F8DB42',
  purple = '#3949AB',
  purpleDark = '#00227B',
  purpleLight = '#6F74DD',
  purpleLighten = '#C4C9E7',
  gray = '#C4C4C4',
  gray100 = '#F5F5F5',
  gray200 = '#F7F7F7',
  gray300 = '#F0F0F0',
  gray400 = '#E9E9E9',
  paleNavy = '#F3F4FC',
  gray600 = '#C4C4C4',
  gray700 = '#D0D0D0',
  gray800 = '#828282',
  gray900 = '#4F4F4F',
  grayDark = '#343434'
}
